/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect } from "react";

export default function TestzugangRedirect() {
    const url = "/_/auth/testzugang";
    useEffect(() => window.location.replace(url), []);
    return <></>;
}